/**
 * formSubmission.ts - Final submit: confirms the Stripe payment (if
 * paying online), then posts the completed registration to the server.
 */
import { CONFIG, state } from './config';
import { validateStep } from './stepNavigation';
import { updateCartSummary } from './cart';
import { confirmStripePayment } from './stripePayment';
import { buildFinalRegistrationPayload } from './registrationData';
import { getCsrfToken } from './utils';
import type { SubmitResponse } from './types';

export function initFormSubmission(): void {
    const form = document.getElementById('CheckoutForm') as HTMLFormElement | null;
    if (!form) return;

    form.addEventListener('submit', async (e: Event) => {
        e.preventDefault();

        if (!validateStep(3)) return;

        const submitBtn = document.getElementById('BtnSubmitRegistration') as HTMLButtonElement | null;
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span> Processing...';
        }

        try {
            let paymentIntentId: string | null = null;

            if (state.paymentMethod === 'Online') {
                // Throws with a user-facing message on decline/cancel/error.
                paymentIntentId = await confirmStripePayment();
            }

            const payload = buildFinalRegistrationPayload(paymentIntentId);

            const response = await fetch(CONFIG.submitRegistrationUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': getCsrfToken()
                },
                body: JSON.stringify(payload)
            });

            const result: SubmitResponse = await response.json();

            if (response.ok && result.success) {
                window.location.href = result.redirectUrl || '/Tournament/Confirmation';
            } else {
                alert(result.message || 'An error occurred during submission.');
                if (submitBtn) submitBtn.disabled = false;
                updateCartSummary();
            }
        } catch (error) {
            console.error('Submission Exception:', error);
            alert(error instanceof Error ? error.message : 'A network error occurred while processing registration.');
            if (submitBtn) submitBtn.disabled = false;
            updateCartSummary();
        }
    });
}